import axiosInstance from './axiosInstance';
import { Blog, BlogRequest } from '../types/blogs';

const API_URL = `${process.env.REACT_APP_API_URL}/api/admin/blogs`;

export interface PaginatedBlogs {
  content: Blog[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export const getAllBlogs = (page: number, size: number, search?: string) => {
  return axiosInstance.get<PaginatedBlogs>(API_URL, {
    params: { page, size, search },
  });
};

export const getBlogById = (id: number) => {
  return axiosInstance.get<Blog>(`${API_URL}/${id}`);
};

export const createBlog = (data: BlogRequest) => {
  return axiosInstance.post<Blog>(API_URL, data);
};

export const updateBlog = (id: number, data: BlogRequest) => {
  return axiosInstance.put<Blog>(`${API_URL}/${id}`, data);
};

export const publishBlog = (id: number) => {
  return axiosInstance.patch<Blog>(`${API_URL}/${id}/publish`);
};

export const toggleBlogPublish = (id: number) => {
  return axiosInstance.patch<Blog>(`${API_URL}/${id}/toggle-publish`);
};

export const saveBlogAsDraft = (id: number) => {
  return axiosInstance.patch<Blog>(`${API_URL}/${id}/draft`);
};

export const uploadBlogCoverImage = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post<{ url: string }>(`${API_URL}/cover-image`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const deleteBlog = (id: number) => {
  return axiosInstance.delete<void>(`${API_URL}/${id}`);
};
